import { render, staticRenderFns } from "./CohortImage.vue?vue&type=template&id=f3989944"
import script from "./CohortImage.vue?vue&type=script&lang=js"
export * from "./CohortImage.vue?vue&type=script&lang=js"
import style0 from "./CohortImage.vue?vue&type=style&index=0&id=f3989944&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports